"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconUser = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#si_user__clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.25a4.273 4.273 0 002.925-1.153l1.32.495A2.706 2.706 0 0112 10.125v1.125a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-1.125c0-1.128.7-2.138 1.755-2.534l1.32-.495A4.274 4.274 0 006 8.25zM5.853 0h.294a2.625 2.625 0 012.616 2.842L8.64 4.322a2.649 2.649 0 01-5.28 0l-.123-1.478A2.625 2.625 0 015.853 0z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "si_user__clip0"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  }))));
};

exports.SvgIconUser = SvgIconUser;